"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable camelcase */
var CACHED_PRICE_VALUES_LIMIT = 200;
var CACHED_PRICES = new Map();
var FORMATTER_BY_LOCALE = new Map(); // Our versions of Node all support Intl, so we only
// need to check for Intl support on browsers.

var SUPPORTS_INTL = typeof window === 'undefined' ? true : 'Intl' in window; // Tencent X5 Example
// eslint-disable-next-line max-len
// Mozilla/5.0 (Linux; Android 10; VOG-AL10 Build/HUAWEIVOG-AL10; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/66.0.3359.126 MQQBrowser/6.2 TBS/45016 Mobile Safari/537.36 MMWEBID/2856 MicroMessenger/7.0.10.1580(0x27000A55) Process/tools NetType/WIFI Language/zh_CN ABI/arm64

var isTencentX5JsCore = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent.indexOf('TBS/') > 0; // https://jira.airbnb.biz/browse/PRODUCT-111789
// Tencent X5 core has formatToParts function, but the native code is correpted.
// web page frozen when this method is called

var SUPPORTS_FORMAT_TO_PARTS = typeof Intl.NumberFormat.prototype.formatToParts === 'function' && !isTencentX5JsCore;

function indexCurrencies(currencies) {
  return (currencies || []).reduce(function (memo, currency) {
    return _objectSpread({}, memo, _defineProperty({}, currency.code, currency));
  }, []);
}

var Localization =
/*#__PURE__*/
function () {
  function Localization() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.init(options);
  }

  var _proto = Localization.prototype;

  _proto.init = function init(options) {
    this.options = _objectSpread({}, options, {
      currencies: indexCurrencies(options.currencies)
    });
  };

  _proto.locale = function locale() {
    return this.options.locale || 'en';
  };

  _proto.language = function language() {
    return this.options.language || 'en';
  };

  _proto.base_direction = function base_direction() {
    return this.options.base_direction || 'ltr';
  }
  /**
   * This function returns the origin of the request and is only reliable when
   * the page is not cached. It is used to exclude some client-side stuff for
   * requests from China.
   */
  ;

  _proto.country = function country() {
    return this.options.country;
  };

  _proto.tld_country = function tld_country() {
    return this.options.tld_country;
  };

  _proto.current_locale_name = function current_locale_name() {
    return this.options.current_locale_name || 'English';
  };

  _proto.languages = function languages() {
    return this.options.languages || [];
  };

  _proto.request_host = function request_host() {
    return this.options.request_host;
  };

  _proto.currencies = function currencies() {
    return Object.keys(this.options.currencies || {});
  };

  _proto.symbolForCurrency = function symbolForCurrency(currency) {
    var currencyOptions = this.currencyOptions(currency);

    if (!currencyOptions) {
      return currency;
    }

    return currencyOptions.unicode_symbol || currencyOptions.symbol;
  };

  _proto.currencySymbolPosition = function currencySymbolPosition(currency) {
    var currencyOptions = this.currencyOptions(currency);
    var position = currencyOptions && currencyOptions.position;
    var locale = this.locale();
    var actualPosition;

    if (position === 'after') {
      actualPosition = 'after';
    } else if (position === 'special') {
      // Special cases; location of Euro sign depends on country
      if (currency === 'EUR') {
        if (['fr', 'de', 'it', 'es'].indexOf(locale) !== -1) {
          actualPosition = 'after';
        } else {
          actualPosition = 'before';
        }
      }
    } else {
      actualPosition = 'before';
    }

    return actualPosition;
  };

  _proto.spaceBetweenPriceAndSymbol = function spaceBetweenPriceAndSymbol(currency) {
    var currencyOptions = this.currencyOptions(currency);
    var space = currencyOptions && currencyOptions.space_between_price_and_symbol;
    return !!space;
  };

  _proto.hideCodeIfSymbolShown = function hideCodeIfSymbolShown(currency) {
    var currencyOptions = this.currencyOptions(currency);
    var hide = currencyOptions && currencyOptions.hide_code_if_symbol_shown;
    return !!hide;
  };

  _proto.currencyOptions = function currencyOptions(currency) {
    if (!this.options.currencies) {
      return null;
    }

    var currencyOptions = this.options.currencies[currency];

    if (!currencyOptions) {
      return null;
    }

    return currencyOptions;
  }
  /**
   * Currency formatting.
   *
   * Arguments:
   *   - (numeric) rawAmount
   *   - (string) currency [optional]
   *   - (object) options [optional]
   *
   * If no currency is passed, it defaults to the value of this.currency(),
   * which is set on pageload.
   *
   * Options:
   *  - (boolean) span: whether to wrap currency symbols in a span for styling.
   *  - (boolean) code: whether to force the letter currency code. Non-boolean
   *                    value defaults to currency-specific behavior.
   *  - (boolean) thousandsDelimiter: whether or not to include the thousands delimiter
   */
  ;

  _proto.priceString = function priceString(rawAmount) {
    var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'USD';
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var amount = rawAmount;
    var str = '';
    var locale = this.locale(); // Since maps are insertion ordered, we want to rotate the most recently
    // used values so that more recently formatted prices stay in the cache longer.

    var cacheKey = [amount, locale, currency, options.code, options.thousandsDelimiter, options.span].join('!');
    var cachedValue = CACHED_PRICES.get(cacheKey); // Push freshly read values to the top of the stack so they are less
    // likely to be purged.

    if (cachedValue !== undefined) {
      CACHED_PRICES["delete"](cacheKey);
      CACHED_PRICES.set(cacheKey, cachedValue);
      return cachedValue;
    } // move negation to beginning of string if amount is a number


    if (typeof amount === 'number' && amount < 0) {
      amount *= -1;
      str += '-';
    }

    var currencyOpts = this.currencyOptions(currency);
    var symbol = this.symbolForCurrency(currency); // Only format amounts that are numbers, leave strings unaltered

    if (typeof amount === 'number') {
      // Latin numbering system.
      var effectiveLocale = locale === 'ar' ? 'ar-u-nu-latn' : locale;

      if (SUPPORTS_INTL && SUPPORTS_FORMAT_TO_PARTS) {
        // Note: this wont work in all cases due to JavaScript floating point issues
        // but it's good enough =]
        var isWholeNumber = Number.isInteger(amount);
        var showThousandsDelimiter = !!options.thousandsDelimiter;
        var formatterKey = [effectiveLocale, isWholeNumber && 'whole', showThousandsDelimiter && 'showThousands'].filter(function (part) {
          return !!part;
        }).join('-');
        var formatter = FORMATTER_BY_LOCALE.get(formatterKey);

        if (!formatter) {
          formatter = new Intl.NumberFormat(effectiveLocale, {
            style: 'currency',
            currency: currency,
            useGrouping: showThousandsDelimiter,
            minimumFractionDigits: isWholeNumber ? 0 : undefined
          });
          FORMATTER_BY_LOCALE.set(formatterKey, formatter);
        }

        amount = formatter.formatToParts(amount).filter(function (part) {
          return part.type !== 'currency';
        }).map(function (part) {
          return part.value;
        }).join('');
      } else if (options.thousandsDelimiter) {
        // Legacy implementation
        if (SUPPORTS_INTL) {
          var _formatter = FORMATTER_BY_LOCALE.get(effectiveLocale);

          if (!_formatter) {
            _formatter = new Intl.NumberFormat(effectiveLocale);
            FORMATTER_BY_LOCALE.set(effectiveLocale, _formatter);
          }

          amount = _formatter.format(amount);
        } else {
          amount = amount.toLocaleString(effectiveLocale);
        }
      }
    }

    var symbolFirst = this.currencySymbolPosition(currency) === 'before';
    var spaceBetween = this.spaceBetweenPriceAndSymbol(currency) ? ' ' : '';

    if (options.span) {
      if (symbolFirst) {
        str += "<span class=\"currency_symbol symbol before\">".concat(symbol, "</span>").concat(spaceBetween).concat(amount);
      } else {
        str += "".concat(amount).concat(spaceBetween, "<span class=\"currency_symbol symbol after\">").concat(symbol, "</span>");
      }
    } else if (symbolFirst) {
      str += [symbol, amount].join(spaceBetween);
    } else {
      str += [amount, symbol].join(spaceBetween);
    }

    if (!this.hideCodeIfSymbolShown(currency) && (options.code === true || options.code !== false && currencyOpts && currencyOpts.show_currency_explicitly)) {
      if (options.span) {
        str += " <span class=\"currency_symbol code after\">".concat(currency, "</span>");
      } else {
        str += " ".concat(currency);
      }
    }

    if (this.base_direction() === 'rtl') {
      // If locale's base direction is right-to-left, add Left-to-Right Mark at
      // beginning and end. This ensures that prices render consistently for
      // all currencies in both left-to-right and right-to-left versions of our
      // website/apps.
      str = "\u200E".concat(str, "\u200E");
    }

    CACHED_PRICES.set(cacheKey, str); // If we're over the cache size limit, remove the least
    // accessed cached value still in the cache.

    if (CACHED_PRICES.size > CACHED_PRICE_VALUES_LIMIT) {
      CACHED_PRICES["delete"](CACHED_PRICES.keys().next().value);
    }

    return str;
  };

  return Localization;
}();

exports["default"] = Localization;


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-l10n/build/Localization.js
// module id = 469
// module chunks = 168707334958949